import axios from "axios";
// import { get } from "sortablejs";

const url = process.env.REACT_APP_API_URL_SUPPLIER; 
const token = localStorage.getItem("token");
const api = axios.create({
  baseURL: url,
  headers: {
    Authorization: token ? `Bearer ${token}` : "",
  },
});

api.interceptors.request.use(
  (config) => {
    const newToken = localStorage.getItem("token");
    if (newToken) {
      config.headers["Authorization"] = `Bearer ${newToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const getPelabuhan = async (page = 1, limit = 10, keyword = "") => {
  const response = await api.get(`/pelabuhan`, {
    params: { page, limit, search: keyword },
  });
  return response.data;
};
const getPropinsi = async () => {
  const response = await api.get(`/propinsi`);
  return response.data;
};

const createPelabuhan = async (data) => {
  try {
    const response = await api.post(`/pelabuhan`, data);
    return response.data;
  } catch (error) {
    console.error("❌ Gagal mengambil data Pelabuhan:", error);
    throw error;
  }
};

export default{ getPelabuhan,
  getPropinsi,
  createPelabuhan
 };